// A2F-764: segmented control — pill-style button group, single select.
//
// Used in the v2 simple-config sub-tabs for choices with 2–5 sensible
// options (heading font, body font, line spacing). For longer option
// lists (>5) we reach for a select instead — segmented controls
// stop being scannable past that count.

interface SegmentedOption<T extends string | number> {
  value: T
  label: string
}

interface SegmentedProps<T extends string | number> {
  value: T
  options: readonly SegmentedOption<T>[]
  onChange: (next: T) => void
  ariaLabel: string
}

export function Segmented<T extends string | number>({
  value,
  options,
  onChange,
  ariaLabel,
}: SegmentedProps<T>) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} className="inline-flex rounded-lg bg-slate-100 p-0.5 flex-wrap">
      {options.map((opt) => {
        const selected = value === opt.value
        return (
          <button
            key={String(opt.value)}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={`px-3 py-1.5 text-[12px] rounded-md transition-colors ${
              selected
                ? 'bg-white text-brand-charcoal shadow-sm font-medium'
                : 'text-slate-600 hover:text-brand-charcoal'
            }`}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
